// import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'
import ApiUtils from '@/utils/api/ApiUtils'


const PageConst= {
  FORM_DEF: {
    editDef: [
      { name: 'user_name', label: 'user_name', type: 'text', required: true }
    ]
  },
  SEARCH_DEF: {
    inputDef: [
      {
        column: 'col-8',
        data: 'user_name',
        type: 'text',
        label: 'user_name',
        props: {
          clearable: true
        }
      }
    ],
    sortDef:[
      {
        text: 'Name Desc',
        value: {order_user_name: 'desc'}
      },
      {
        text: 'Name Asc',
        value: {order_user_name: 'asc'}
      },
    ],
  },
  LIST_DEF: {
    // tableDef: [
    // { name: 'name', label: 'Name', align: 'left', sortable: true },
    // { name: 'description', label: 'Description', align: 'left', sortable: false }
    // ]
    // filterDef: [
    // { name: 'name', label: 'Name', type: 'text' },
    // ]
  },
  ACTION: {
    doAdd: { api: 'T0010UsersService.doAdd'},
    getEdit: { api: 'T0010UsersService.getEdit'},
    doEdit: { api: 'T0010UsersService.doEdit'},
    doRead: { api: 'T0010UsersService.doRead'},
    doDelete: { api: 'T0010UsersService.doDelete'},
    doBrowse: { api: 'T0010UsersService.doBrowse'},
    doBrowse_AtDataTable: { api: 'T0010UsersService.doBrowse_AtDataTable'},
    getTableColumnDefsDataForSearchTable: { api: 'T0010UsersService.getTableColumnDefsDataForSearchTable'},
    getTableColumnDefsDataForAtForm: { api: 'T0010UsersService.getTableColumnDefsDataForAtForm'},
  },
}

const module = {
  state: {
    PageConst,

    // set default here
    searchInfo:{
    },
    // set default here
    orderBy:PageConst.SEARCH_DEF.sortDef[0].value,
  },

  getters: {

  },

  mutations: {

  },
  actions: {
    async requestApproval ({ commit,state }, payload) {
      const res = await ApiUtils.postData({ data: [
        { api: state.PageConst.ACTION.requestApproval.api,
          input: state.row
        }] })
      return res[0].output
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
